export const SETUP_OPTION_SELF = 'SELF';
export const SETUP_OPTION_PROF = 'PROFESSIONAL';
export const INVALID_PHONE_MESSAGE = 'Please enter a valid 10 digit phone number.';
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address';
export const RECOMMENDED ='Recommended*'
export const RECOMMENDEDMOV ='Recommended'
export const HIGH ='high'
export const CRITICAL ='critical'
export const PRO ='Pro'


